const details = {
    leaf: {
        img: {
            src: {
                basic: require('./assets/icon/icon-leaf-sand.svg'),
                hover: require('./assets/icon/icon-leaf-green.svg')
            },
            alt: ''
        },
        label: 'Vegan',
        content: {
            title: 'Vegan',
            text: ['All products at Odo Foods are vegan friendly because we don’t want to exclude anybody from eating our simple snacks. We do make some exclusions, but we do that on purpose as they are the ones we don’t wants – all our products are free from gluten, wheat and any added sugar.']
        }
    },
    heart: {
        img: {
            src: {
                basic: require('./assets/icon/icon-heart-sand.svg'),
                hover: require('./assets/icon/icon-heart-green.svg')
            },
            alt: ''
        },
        label: 'High in vitamins',
        content: {
            title: 'High in vitamins',
            text: ['All products at Odo Foods are vegan friendly because we don’t want to exclude anybody from eating our simple snacks. We do make some exclusions, but we do that on purpose as they are the ones we don’t wants – all our products are free from gluten, wheat and any added sugar.']
        }
    },
    intestine: {
        img: {
            src: {
                basic: require('./assets/icon/icon-intestine-sand.svg'),
                hover: require('./assets/icon/icon-intestine-green.svg')
            },
            alt: ''
        },
        label: 'Clean energy',
        content: {
            title: 'Clean energy',
            text: ['All products at Odo Foods are vegan friendly because we don’t want to exclude anybody from eating our simple snacks. We do make some exclusions, but we do that on purpose as they are the ones we don’t wants – all our products are free from gluten, wheat and any added sugar.']
        }
    },
    flash: {
        img: {
            src: {
                basic: require('./assets/icon/icon-flash-sand.svg'),
                hover: require('./assets/icon/icon-flash-green.svg')
            },
            alt: ''
        },
        label: 'Source of&nbsp;protein',
        content: {
            title: 'Source of protein',
            text: ['All products at Odo Foods are vegan friendly because we don’t want to exclude anybody from eating our simple snacks. We do make some exclusions, but we do that on purpose as they are the ones we don’t wants – all our products are free from gluten, wheat and any added sugar.']
        }
    },
    flagUk: {
        img: {
            src: {
                basic: require('./assets/icon/icon-flag-uk-sand.svg'),
                hover: require('./assets/icon/icon-flag-uk-green.svg')
            },
            alt: ''
        },
        label: 'All made in&nbsp;UK',
        content: {
            title: 'All made in UK',
            text: ['All products at Odo Foods are vegan friendly because we don’t want to exclude anybody from eating our simple snacks. We do make some exclusions, but we do that on purpose as they are the ones we don’t wants – all our products are free from gluten, wheat and any added sugar.']
        }
    },
    apple: {
        img: {
            src: {
                basic: require('./assets/icon/icon-apple-sand.svg'),
                hover: require('./assets/icon/icon-apple-green.svg')
            },
            alt: ''
        },
        label: 'Only natural ingredients',
        content: {
            title: 'Only natural ingredients',
            text: ['All products at Odo Foods are vegan friendly because we don’t want to exclude anybody from eating our simple snacks. We do make some exclusions, but we do that on purpose as they are the ones we don’t wants – all our products are free from gluten, wheat and any added sugar.']
        }
    }
}

// Product data
const products = [
    {
        name: 'cocoa',
        slug: 'cocoa-ball',
        color: '#ccbab6',
        label: 'Cocoa Ball',
        path: null,
        pack: 'balls',
        baseline: 'Treat yourself whilst staying healthy',
        img: {
            src: require('./assets/products/cocoa.png'),
            alt: 'Cocoa ball'
        },
        amazon: 'https://www.amazon.co.uk/',
        resume: 'A healthy snack with a rich flavour of natural chocolate, providing a beautiful balance between taste and nutrition.',
        meta: {
            title: '0do Foods - Cocoa Ball',
            description: 'A healthy snack with a rich flavour of natural chocolate by Odo Foods'
        },
        content: [
            {
                type: 'cover',
                // price: '£8',
                title: 'Cocoa Ball',
                baseline: '',
                resume: 'A healthy snack with a rich flavour of natural chocolate, providing a beautiful balance between taste and nutrition.'
            },
            {
                type: 'details',
                title: 'Simple, tasty and nutritious',
                photo: {
                    src: require('./assets/products/product-landscape-cocoa-ball-x1.jpg'),
                    srcset: require('./assets/products/product-landscape-cocoa-ball-x2.jpg') + ' x2',
                    alt: 'Ball photo'
                },
                list: [
                    details.heart,
                    details.intestine,
                    details.flagUk,
                    details.apple
                ]
            },
            {
                type: 'ingredients',
                list: [
                    'Gluten free oats', 'Coconut flour', 'Date paste', 'Sunflower lecithin', 'Honey', 'Coconut oil', 'Apple juice concentrate', 'Rapeseed oil', 'Sunflower protein', 'Cocoa', 'Natural chocolate flavour'
                ]
            },
            {
                type: 'data',
                title: 'odo cocoa',
                resume: 'Free from gluten, wheat, dairy, soy, egg, nuts and seeds, and only includes naturally occurring sugars. Non-GMO.',
                button: {
                    label: 'Learn more about nutrition',
                    to: '/simple-eating'
                },
                table: {
                    list: [
                        ['strong', 'Nutritional information', 'per 100g', 'per 42g serving'],
                        ['span', 'Energy (kj)', 1389, 583],
                        ['span', 'Energy (kcal)', 315, 132],
                        ['em', 'Fat (g)', 15, 6],
                        ['span', 'Saturates (g)', 7, 3],
                        ['em', 'Carbohydrates (g)', 41, 17],
                        ['span', 'Sugars (g)', 29, 12],
                        ['span', 'Fibre (g)', 5, 2],
                        ['span', 'Protein (g)', 9, 4],
                        ['span', 'Salt (g)', 0, 0]
                    ]
                }
            },
            {
                type: 'other',
                title: 'Discover the cacao ball',
                resume: 'Low sugar but high taste!'
            }
        ]
    },
    {
        name: 'cacao',
        slug: 'cacao-ball',
        color: '#b3cebd',
        label: 'Cacao Ball',
        path: null,
        pack: 'balls',
        baseline: 'Reduce the carbs but not the taste',
        img: {
            src: require('./assets/products/cacao.png'),
            alt: 'Cacao ball'
        },
        amazon: 'https://www.amazon.co.uk/',
        resume: 'lA low carbohydrate and low sugar alternative snack, which is high in energy and provides a sumptuous taste of dark chocolate.',
        meta: {
            title: '0do Foods - Cacao Ball',
            description: 'A low carbohydrate and low sugar alternative snack by Odo Foods'
        },
        content: [
            {
                type: 'cover',
                // price: '£8',
                title: 'Cacao Ball',
                baseline: '',
                resume: 'A low carbohydrate and low sugar alternative snack, which is high in energy and provides a sumptuous taste of dark chocolate.'
            },
            {
                type: 'details',
                title: 'Less carbs but more energy',
                photo: {
                    src: require('./assets/products/product-landscape-cacao-ball-x1.jpg'),
                    srcset: require('./assets/products/product-landscape-cacao-ball-x2.jpg') + ' x2',
                    alt: 'Balls photo'
                },
                list: [
                    details.heart,
                    details.intestine,
                    details.flagUk,
                    details.apple
                ]
            },
            {
                type: 'ingredients',
                list: [
                    'Raw cacao', 'Coconut flour', 'Cream of coconut', 'Sunflower lecithin', 'Pea protein', 'Coconut oil', 'Apple juice concentrate', 'Raw cacao nibs', 'Citrus fibre', 'Coconut chips', 'Natural chocolate flavour'
                ]
            },
            {
                type: 'data',
                title: 'odo cacao',
                resume: 'Free from gluten, wheat, dairy, soy, egg, nuts and seeds, and only includes naturally occurring sugars. Non-GMO.<br>Only 2.5 net grams of carbohydrates per 42 gram serving. ',
                button: {
                    label: 'Learn more about nutrition',
                    to: '/simple-eating'
                },
                table: {
                    list: [
                        ['strong', 'Nutritional information', 'per 100g', 'per 42g serving'],
                        ['span', 'Energy (kj)', 1863, 783],
                        ['span', 'Energy (kcal)', 445, 187],
                        ['em', 'Fat (g)', 39, 17],
                        ['span', 'Saturates (g)', 33, 14],
                        ['em', 'Carbohydrates (g)', 11, 5],
                        ['span', 'Sugars (g)', 5, 2],
                        ['span', 'Fibre (g)', 5, 2],
                        ['span', 'Protein (g)', 15, 6],
                        ['span', 'Salt (g)', 0, 0]
                    ]
                }
            },
            {
                type: 'other',
                title: 'Discover the oat ball',
                resume: 'A chocolatey balance between taste and nutrition!'
            }
        ]
    }
]

// pages data
const pages = [
    {
        name: 'home',
        path: '/',
        label: '0DO Foods',
        headerGreen: false,
        footer: true,
        meta: {
            title: '0do Foods',
            description: 'Find your balance with Odo Foods'
        }
    },
    {
        name: 'story',
        path: '/the-story',
        label: 'The story',
        headerGreen: false,
        footer: true,
        meta: {
            title: '0do Foods - Story',
            description: 'The story around Odo Foods'
        }
    },
    {
        name: 'mission',
        path: '/the-mission',
        label: 'The mission',
        headerGreen: false,
        footer: true,
        meta: {
            title: '0do Foods - Mission',
            description: 'Odo Foods mission to simplify the approach to nutrition'
        }
    },
    {
        name: 'eating',
        path: '/simple-eating',
        label: 'Simple eating',
        headerGreen: false,
        footer: true,
        meta: {
            title: '0do Foods - Simple eating',
            description: 'Each body is different, find your own balance with Odo Foods'
        }
    },
    {
        name: 'products',
        path: '/products',
        label: 'Products',
        headerGreen: true,
        footer: false,
        meta: {
            title: '0do Foods - Products',
            description: 'Selection of Odo Foods products'
        }
    },
    {
        name: 'product',
        path: '/products/:slug(' + products.map(({ slug }) => slug).join('|') + ')',
        label: 'Product',
        headerGreen: false,
        footer: true
    },
    {
        name: 'policy',
        path: '/privacy-policy',
        label: 'Privacy policy',
        headerGreen: false,
        footer: true,
        meta: {
            title: '0do Foods - Privacy Policy',
            description: 'Odo Foods privacy policies'
        }
    },
    {
        name: 'terms',
        path: '/terms-and-condition',
        label: 'Terms & Conditions',
        headerGreen: false,
        footer: true,
        meta: {
            title: '0do Foods - Terms and Conditions',
            description: 'Odo Foods terms and conditions'
        }
    },
    {
        name: '404',
        path: '*',
        label: 'Error 404',
        headerGreen: false,
        footer: true,
        meta: {
            title: '0do Foods - Page not found',
            description: 'Odo Foods 404'
        }
    }
]

// Helpers
const error = message => console.error(message)
const getPage = name => pages.find(({ name: currentName }) => currentName === name) || error('Page name "' + name + '" not found')
const getProduct = name => products.find(({ name: currentName }) => currentName === name) || error('Product name "' + name + '" not found')
const getProductBySlug = slug => products.find(({ slug: currentSlug }) => currentSlug === slug) || error('Product slug "' + slug + '" not found')

// Populate product paths
{
    const productPath = getPage('product').path
    products.forEach(product => product.path = productPath
        .replace(':slug', product.slug)
        .replace(/\(.+\)/, ''))
}

// Exports
export { getPage, getProduct, getProductBySlug }
export default {
    pages,
    products,
    socials: {
        facebook: '//www.facebook.com/0daysoff/',
        instagram: '//www.instagram.com/0daysoff1/?hl=fr',
        youtube: '//www.youtube.com/channel/UCfz95m73nmtNzC0fnUhA9-g'
    },
    mailto: 'info@zerodaysoff.co.uk'
}
